import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AppSection() {
  const { ref, isVisible } = useScrollReveal(0.2);

  return (
    <section id="app" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div
          ref={ref}
          className={`bg-gradient-to-br from-primary-100/80 via-accent-100/40 to-primary-100/60 rounded-xl p-6 md:p-12 flex flex-col md:flex-row items-center gap-6 md:gap-12 border border-primary-200/40 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-primary-500/20">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">
              下载黑料718移动客户端
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px]">
              随时随地浏览正能量黑料精选内容，支持 iOS 与 Android 双平台。推送精选好文不遗漏，第一时间获取最新正能量故事与暖心黑料。
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0 flex-wrap justify-center">
            <a
              href="#app"
              className="whitespace-nowrap inline-flex items-center px-6 py-3 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-800 active:scale-[0.98] transition-all cursor-pointer"
            >
              <i className="ri-apple-fill text-lg mr-2"></i>iOS 版
            </a>
            <a
              href="#app"
              className="whitespace-nowrap inline-flex items-center px-6 py-3 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-800 active:scale-[0.98] transition-all cursor-pointer"
            >
              <i className="ri-android-fill text-lg mr-2"></i>Android 版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}